import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.promise";
import _regeneratorRuntime from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/asyncToGenerator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _toConsumableArray from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getOrganizationsAndGroups, storeOrganization, getOrganization, updateOrganization, deleteOrganization } from "src/models/Organization";
import errorDialog from "src/functions/function-show-error-message";
import { commitPagination, hasNextPage } from "src/store/utils/pagination";
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';;

var getErrorPayload = function getErrorPayload(error) {
  var _error$response;

  return (error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) || {
    message: (error === null || error === void 0 ? void 0 : error.message) || "Unexpected error"
  };
};

var sortByArchivedDate = function sortByArchivedDate(a, b) {
  if (a.archived === null && b.archived !== null) {
    return -1;
  }

  if (a.archived !== null && b.archived === null) {
    return 1;
  }

  if (a.archived !== null && b.archived !== null) {
    return new Date(a.archived) - new Date(b.archived);
  }

  return 0;
};

var normalizeOrganization = function normalizeOrganization(item) {
  var groups = item.admin ? item.groups.data : item.groups.data.filter(function (group) {
    return !group.archived;
  });
  return _objectSpread(_objectSpread({}, item), {}, {
    groups: _objectSpread(_objectSpread({}, item.groups), {}, {
      data: _toConsumableArray(groups).sort(sortByArchivedDate)
    })
  });
}; // Init state


var initState = function initState() {
  return {
    organizations: [],
    organization: null,
    orgsPagination: {
      currentPage: 0,
      total_pages: 1
    },
    hasMoreOrganizations: true,
    loading: {
      pageLoading: false
    }
  };
}; // State object


var state = initState(); // Mutations

var mutations = {
  /**
   * Sets the value of state.organizations to the given payload data.
   * If the organization user is not an admin, archived groups are excluded from the data array.
   * The data array for each group object is sorted in ascending order by the archived property.
   */
  setOrganizations: function setOrganizations(state, payload) {
    state.organizations = payload.data.map(normalizeOrganization);
  },
  appendOrganizations: function appendOrganizations(state, payload) {
    var normalizedOrganizations = payload.data.map(normalizeOrganization);
    state.organizations = [].concat(_toConsumableArray(state.organizations), _toConsumableArray(normalizedOrganizations));
  },
  updateOrgsPagination: function updateOrgsPagination(state, pagination) {
    state.orgsPagination.currentPage = pagination.currentPage;
    state.orgsPagination.total_pages = pagination.total_pages;
  },
  setHasMoreOrganizations: function setHasMoreOrganizations(state, value) {
    state.hasMoreOrganizations = value;
  },
  setOrganization: function setOrganization(state, value) {
    state.organization = value;

    if (value && value.id) {
      LocalStorage.set("selectedOrganizationId", value.id);
    } else {
      LocalStorage.remove("selectedOrganizationId");
    }
  },
  setUnarchiveOrganizationGroup: function setUnarchiveOrganizationGroup(state, groupId) {
    state.organizations.forEach(function (item) {
      item.groups.data.forEach(function (group) {
        if (group.id === groupId) {
          group.archived = null;
        }
      });
    });
  },
  resetOrganization: function resetOrganization(state) {
    state.organization = "";
  },
  setPageLoading: function setPageLoading(state, payload) {
    state.loading.pageLoading = payload;
  },
  RESET: function RESET(state) {
    var newState = initState();
    Object.keys(newState).forEach(function (key) {
      state[key] = newState[key];
    });
  }
}; // Actions

var actions = {
  setOrganization: function setOrganization(_ref, value) {
    var commit = _ref.commit;
    commit("setOrganization", value);
  },
  fetchOrganizationsAndGroups: function fetchOrganizationsAndGroups(_ref2) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var commit, _response$data, _response$data2, _response$data2$meta, response, normalizedPayload;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref2.commit;
              commit("setPageLoading", true);
              commit("setHasMoreOrganizations", true);
              _context.prev = 3;
              _context.next = 6;
              return getOrganizationsAndGroups(1);

            case 6:
              response = _context.sent;
              normalizedPayload = _objectSpread(_objectSpread({}, response.data), {}, {
                data: Array.isArray((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) ? response.data.data : Array.isArray(response.data) ? response.data : []
              });
              commit("setOrganizations", normalizedPayload);
              commitPagination(commit, (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$meta = _response$data2.meta) === null || _response$data2$meta === void 0 ? void 0 : _response$data2$meta.pagination, {
                update: "updateOrgsPagination",
                setHasMore: "setHasMoreOrganizations"
              });
              commit("setPageLoading", false);
              _context.next = 17;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](3);
              console.log(getErrorPayload(_context.t0));
              commit("setPageLoading", false);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 13]]);
    }))();
  },
  fetchMoreOrganizations: function fetchMoreOrganizations(_ref3) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var commit, state, nextPage, _response$data3, _response$data4, _response$data4$meta, response, normalizedPayload;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref3.commit, state = _ref3.state;

              if (hasNextPage(state, "orgsPagination")) {
                _context2.next = 4;
                break;
              }

              commit("setHasMoreOrganizations", false);
              return _context2.abrupt("return");

            case 4:
              commit("setPageLoading", true);
              nextPage = state.orgsPagination.currentPage + 1;
              _context2.prev = 6;
              _context2.next = 9;
              return getOrganizationsAndGroups(nextPage);

            case 9:
              response = _context2.sent;
              normalizedPayload = _objectSpread(_objectSpread({}, response.data), {}, {
                data: Array.isArray((_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.data) ? response.data.data : Array.isArray(response.data) ? response.data : []
              });
              commit("appendOrganizations", normalizedPayload);
              commitPagination(commit, (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : (_response$data4$meta = _response$data4.meta) === null || _response$data4$meta === void 0 ? void 0 : _response$data4$meta.pagination, {
                update: "updateOrgsPagination",
                setHasMore: "setHasMoreOrganizations"
              });
              commit("setPageLoading", false);
              _context2.next = 20;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](6);
              console.log(getErrorPayload(_context2.t0));
              commit("setPageLoading", false);

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 16]]);
    }))();
  },
  createOrganization: function createOrganization(_ref4, request) {
    var commit = _ref4.commit;
    return new Promise(function (resolve) {
      storeOrganization(request).then(function () {
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
      });
    });
  },
  fetchOrganization: function fetchOrganization(_ref5, organizationId) {
    var commit = _ref5.commit;
    commit("setPageLoading", true);
    return new Promise(function (resolve) {
      getOrganization(organizationId).then(function (response) {
        commit("setOrganization", response.data);
        commit("setPageLoading", false);
        resolve();
      }).catch(function (e) {
        commit("setPageLoading", false);
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
      });
    });
  },
  updateTheOrganization: function updateTheOrganization(_ref6, request) {
    var state = _ref6.state;
    return new Promise(function (resolve, reject) {
      updateOrganization(state.organization.id, request).then(function () {
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        console.log(e.response);
        reject();
      });
    });
  },
  deleteTheOrganization: function deleteTheOrganization(_ref7, organizationId) {
    var commit = _ref7.commit;
    return new Promise(function (resolve, reject) {
      deleteOrganization(organizationId).then(function () {
        resolve();
      }).catch(function (e) {
        console.log(e.response);
        reject();
      });
    });
  }
}; // Getter functions

var getters = {
  organizations: function organizations(state) {
    return state.organizations;
  },
  organization: function organization(state) {
    return state.organization;
  },
  hasMoreOrganizations: function hasMoreOrganizations(state) {
    return state.hasMoreOrganizations;
  },
  pageLoading: function pageLoading(state) {
    return state.loading.pageLoading;
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};